import { Tokens, UserData } from 'interfaces';

export const _authToken = {
    key: '30PAY__AUTH_TOKEN',
    get: function (): Tokens | null {
        const data = localStorage.getItem(_authToken.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: Tokens) => {
        localStorage.setItem(_authToken.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(_authToken.key);
    },
};

export const _userPhoneNumber = {
    key: '30PAY__USER_PHONE_NUMBER',
    get: function (): string | undefined {
        const data = localStorage.getItem(_userPhoneNumber.key);
        if (data) {
            return data;
        }
        return undefined;
    },
    set: (value: string) => {
        localStorage.setItem(_userPhoneNumber.key, value);
    },
    remove: () => {
        localStorage.removeItem(_userPhoneNumber.key);
    },
};

export const _hasFirstTimeVideoSeen = {
    key: '30PAY__IS__SEEN__FIRST_TIME__VIDEO',
    get: function (): boolean | undefined {
        const data = localStorage.getItem(_hasFirstTimeVideoSeen.key);
        if (data) {
            return JSON.parse(data);
        }
        return undefined;
    },
    set: (value: boolean) => {
        localStorage.setItem(_hasFirstTimeVideoSeen.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(_hasFirstTimeVideoSeen.key);
    },
};

export const _userProfile = {
    key: '30PAY__USER_PROFILE',
    get: function (): UserData | null {
        const data = localStorage.getItem(_userProfile.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: UserData) => {
        localStorage.setItem(_userProfile.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(_userProfile.key);
    },
};

export const _hasFirstTimeBankAccountVideoSeen = {
    key: '30PAY__IS__SEEN__FIRST_TIME__BANK_ACCOUNT__VIDEO',
    get: function (): boolean | undefined {
        const data = localStorage.getItem(_hasFirstTimeBankAccountVideoSeen.key);
        if (data) {
            return JSON.parse(data);
        }
        return undefined;
    },
    set: (value: boolean) => {
        localStorage.setItem(_hasFirstTimeBankAccountVideoSeen.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(_hasFirstTimeBankAccountVideoSeen.key);
    },
};




export const _hasRejectedUpgradeModalShown = {
    key: '30PAY__HAS__REJECTED__UPGRADE__MODAL__SHOWN',
    get: function (): boolean | undefined {
        const data = localStorage.getItem(_hasRejectedUpgradeModalShown.key);
        if (data) {
            return JSON.parse(data);
        }
        return undefined;
    },
    set: (value: boolean) => {
        localStorage.setItem(_hasRejectedUpgradeModalShown.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(_hasRejectedUpgradeModalShown.key);
    },
};

export const _hasBlackFridayModalShown = {
    key: '30PAY__HAS__BLACK__FRIDAY__MODAL__SHOWN',
    get: function (): boolean | undefined {
        const data = localStorage.getItem(_hasBlackFridayModalShown.key);
        if (data) {
            return JSON.parse(data);
        }
        return undefined;
    },
    set: (value: boolean) => {
        localStorage.setItem(_hasBlackFridayModalShown.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(_hasBlackFridayModalShown.key);
    },
};